export const getProficiencyConfig = (proficiency) => {
  const configs = {
    0: { 
      bg: 'bg-gradient-to-br from-red-400 to-red-600', 
      hover: 'hover:from-red-500 hover:to-red-700', 
      label: 'Learning',
      emoji: '🤸‍♂️',
      ring: 'focus:ring-red-400',
      glow: 'hover:shadow-red-400/50',
      description: 'Still getting the feel for it'
    },
    1: { 
      bg: 'bg-gradient-to-br from-amber-400 to-orange-500', 
      hover: 'hover:from-amber-500 hover:to-orange-600', 
      label: 'Progressing',
      emoji: '🏃‍♂️',
      ring: 'focus:ring-amber-400',
      glow: 'hover:shadow-amber-400/50',
      description: 'Getting more consistent'
    },
    2: { 
      bg: 'bg-gradient-to-br from-green-400 to-emerald-600', 
      hover: 'hover:from-green-500 hover:to-emerald-700', 
      label: 'Mastered',
      emoji: '🎯',
      ring: 'focus:ring-green-400',
      glow: 'hover:shadow-green-400/50',
      description: 'Nailed it every time!'
    },
    default: { 
      bg: 'bg-gradient-to-br from-gray-300 to-gray-400', 
      hover: 'hover:from-gray-400 hover:to-gray-500', 
      label: 'Unknown',
      emoji: '❓',
      ring: 'focus:ring-gray-400',
      glow: 'hover:shadow-gray-400/50',
      description: 'Not sure yet'
    }
  };
  
  return configs[proficiency] || configs.default;
};

export const getProficiencyLevels = () => [
  { value: 0, label: 'Learning', emoji: '🤸‍♂️', desc: 'Still figuring it out' },
  { value: 1, label: 'Progressing', emoji: '🏃‍♂️', desc: 'Getting more consistent' },
  { value: 2, label: 'Mastered', emoji: '🎯', desc: 'Nailed it!' }
];